import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminCoopPartnersNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('coop-partner');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
